import { api } from './client';
import type { Coupon, CouponCreateRequest, CouponUpdateRequest } from '../types';

export const couponsApi = {
  list: () => api.get<Coupon[]>('/coupons').then((r) => r.data),

  create: (body: CouponCreateRequest) =>
    api.post<Coupon>('/coupons', body).then((r) => r.data),

  update: (id: number, body: CouponUpdateRequest) =>
    api.put<Coupon>(`/coupons/${id}`, body).then((r) => r.data),

  deactivate: (id: number) =>
    api.delete<void>(`/coupons/${id}`).then((r) => r.data),
};
